export enum ContractHandlerType {
    'openZeppelin' = 'openZeppelin'
  }
  